export default __webpack_public_path__ + "static/media/logo.f4e243c1.png";